module.exports = __webpack_public_path__ + "static/media/广发证券@2x.634a0843.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/广发证券@2x.png
// module id = 1544
// module chunks = 0